import * as RLS from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Skeleton: React.FC<RLS.SkeletonProps> = ({
	containerClassName = "",
	className = "",
	...props
}) => {
	return (
		// eslint-disable-next-line react/jsx-pascal-case
		<RLS.default
			{...props}
			containerClassName={`skeleton-container ${containerClassName}`}
			className={`skeleton ${className}`}
		/>
	);
};
export const SkeletonAlt: React.FC<RLS.SkeletonProps> = ({
	className = "",
	...props
}) => {
	return (
		// eslint-disable-next-line react/jsx-pascal-case
		<RLS.default
			{...props}
			containerClassName={`skeleton-container ${className}`}
			className={"skeleton"}
		/>
	);
};
export default Skeleton;
